export default {
  // Navigation
  'nav.about': 'À propos',
  'nav.services': 'Services',
  'nav.team': 'Équipe',
  'nav.investment': 'Investissement',
  'nav.contact': 'Contact',
  'nav.careers': 'Carrières',
  'nav.getStarted': 'Commencer',

  // Careers page
  'careers.badge': 'Nous recrutons',
  'careers.heroTitle': 'Nous bâtissons de vrais produits, pas seulement des idées',
  'careers.heroSubtitle':
    'Flexy Group conçoit des logiciels, des plateformes et une infrastructure modernes pour les équipes qui veulent avancer vite—sans sacrifier la qualité. Découvrez nos postes ouverts et évoluez avec nous.',
  'careers.heroCta': 'Voir les postes',
  'careers.heroSecondaryCta': 'Écrire aux recruteurs',
  'careers.openRolesTitle': 'Postes ouverts',
  'careers.openRolesSubtitle': 'Sélectionnez un poste pour lire la description complète et les modalités de candidature.',
  'careers.viewRole': 'Voir la description complète',
  'careers.backToCareers': 'Tous les postes',
  'careers.jobNotFound': 'Cette offre n’est plus disponible.',
  'careers.jobSeniorCyclos.cardExcerpt':
    'Développeur Cyclos senior pour notre plateforme de paiements numériques et de banque en ligne—AWS, intégrations, sécurité et mentorat. Sur place à LaSalle, Montréal. 95 000 $ CA/an.',
  'careers.statusActive': 'Actif',
  'careers.postedOn': 'Publié le {{date}}',
  'careers.applyCta': 'Postuler par courriel',
  'careers.detail.location': 'Lieu',
  'careers.detail.employment': 'Emploi',
  'careers.detail.workArrangement': 'Mode de travail',
  'careers.detail.hours': 'Heures',
  'careers.detail.salary': 'Salaire de base',
  'careers.detail.vacancies': 'Postes',
  'careers.detail.startDate': 'Date de début',
  'careers.detail.language': 'Langue',

  // Common
  'common.learnMore': 'En savoir plus',
  'common.readMore': 'Lire plus',
  'common.getStarted': 'Commencer',
  'common.contactUs': 'Nous contacter',
  'common.viewMore': 'Voir plus',
  'common.connect': 'Se connecter',
  'common.copyright': '© Flexy Group, Inc.',
  'common.poweredBy': 'Propulsé par Readdy',

  // Footer
  'footer.description': 'Alimenter la croissance grâce à la technologie et aux investissements stratégiques. Nous nous spécialisons dans les solutions de paiement numérique, les logiciels bancaires et les investissements technologiques stratégiques.',
  'footer.sections': 'Sections',
  'footer.services': 'Services',
  'footer.aboutUs': 'À propos de nous',
  'footer.digitalPayments': 'Solutions de paiement numérique',
  'footer.bankingSoftware': 'Logiciels bancaires',
  'footer.customDevelopment': 'Développement de logiciels personnalisés',
  'footer.strategicInvestment': 'Investissement technologique stratégique',
  'footer.cyclosSupport': 'Support Cyclos',
};
